import {Model} from "@/store/models/model";
import {Country} from "@/store/models/country";
import axios from "@/store/vue-axios";
import DomainTld from "@/store/models/domain/domain_tld";

export class DomainPriceDiscount extends Model {

  static entity = 'domain_price_discounts'
  static primaryKey = 'tld'
  static apiEntity = 'discounts'

  static fields() {
    return {
      tld: this.string(''),

      start_date: this.attr(null),
      end_date: this.attr(null),
      years: this.attr(null),
      price: this.attr(null),
      type: this.attr(null),

    }
  }

  static async fetch() {
    const result = await axios.get("accounting/pricing/domains/discounts")

    this.insert({data: Object.values(result.data.discounts)})
  }

}

export default DomainPriceDiscount



// WEBPACK FOOTER //
// ./src/store/models/domain/domain_price_discount.js